const Loader = () => {
    return (
        <div className="w-full h-full fixed top-0 left-0 inset-0 flex justify-center items-center">
            <div className="absolute animate-spin rounded-full h-32 w-32 border-t-4 border-b-4 border-primary"></div>
            <img src="./safe-haul.png" alt='' className="rounded-full h-28 w-28" />
        </div>
    )
}

export default Loader